import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, notFound } from "@tanstack/react-router"

import {
  getClientOverviewStatsQueryOptions,
  getExtendedClientQueryOptions,
} from "~/modules/clients/clients.queries"
import { ClientOverview } from "~/modules/clients/components/client-overview"

export const Route = createFileRoute(
  "/_protected-layout/_os-layout/clients/$clientSlug/overview",
)({
  component: RouteComponent,
  loader: async ({ context, params }) => {
    const [extendedClient] = await Promise.all([
      context.queryClient.ensureQueryData(
        getExtendedClientQueryOptions({ clientSlug: params.clientSlug }),
      ),
      context.queryClient.ensureQueryData(
        getClientOverviewStatsQueryOptions({ clientSlug: params.clientSlug }),
      ),
    ])

    if (!extendedClient) {
      throw notFound()
    }
  },
})

function RouteComponent() {
  const { clientSlug } = Route.useParams()

  const { data: client } = useSuspenseQuery(
    getExtendedClientQueryOptions({ clientSlug }),
  )
  const { data: stats } = useSuspenseQuery(
    getClientOverviewStatsQueryOptions({ clientSlug }),
  )

  if (!client) {
    throw notFound()
  }

  return <ClientOverview client={client} stats={stats} />
}
